var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showBackHome && _vm.isNeed)?_c('div',{staticClass:"go-top go-home",on:{"click":_vm.home}},[_c('span',{staticClass:"iconfont icon-homepage"})]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"go-top",on:{"click":_vm.top}},[_c('span',{staticClass:"iconfont icon-top"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }